var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45883 12.4827C6.49557 12.4743 6.52919 12.4558 6.55583 12.4291L11.8889 7.09607L9.40387 4.61105L4.07081 9.94411C4.04418 9.97075 4.0256 10.0044 4.01723 10.0411L3.29688 13.2031L6.45883 12.4827Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.111 3.90395L12.596 6.38896L13.6154 5.36955C13.9948 4.99018 13.9948 4.37509 13.6154 3.99572L12.5042 2.88454C12.1249 2.50516 11.5098 2.50516 11.1304 2.88454L10.111 3.90395Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/ic_pencil.0e2fc0607a1d7da8dd46894aa447459c.svg";
export { ForwardRef as ReactComponent };